function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-6aad501b\",\"scoped\":false,\"hasInlineConfig\":true}!./tile-medium.css")
}
var normalizeComponent = require("!../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader?{\"presets\":[[\"/home/travis/build/fabrikaodua/frontend-ui-modus-8/node_modules/babel-preset-env/lib/index.js\",{\"debug\":false,\"loose\":false,\"modules\":false,\"useBuiltIns\":true,\"include\":[],\"exclude\":[],\"targets\":{\"browsers\":[\"last 3 versions\"]}}]],\"plugins\":[\"/home/travis/build/fabrikaodua/frontend-ui-modus-8/node_modules/babel-plugin-syntax-dynamic-import/lib/index.js\",\"/home/travis/build/fabrikaodua/frontend-ui-modus-8/node_modules/babel-plugin-transform-object-rest-spread/lib/index.js\",\"/home/travis/build/fabrikaodua/frontend-ui-modus-8/node_modules/babel-plugin-transform-class-properties/lib/index.js\"]}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/extract-loader/lib/extractLoader.js!../../../node_modules/html-loader/index.js??ref--13-2!./tile-medium.vue"
/* template */
import __vue_template__ from "!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6aad501b\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/extract-loader/lib/extractLoader.js!../../../node_modules/html-loader/index.js??ref--13-2!./tile-medium.vue"
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/tile-medium/tile-medium.vue
// module id = ./src/components/tile-medium/tile-medium.vue
// module chunks = index